import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import VideoWebcamRecorder from './Recorder';
import { CloudfrontVideoFormat } from '../videos/CloudfrontVideoFormat';
import loading from './../loading-gif-png-5.gif';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function Celebrate(props) {
  // Initialize variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [displayCelebrateVideo, setDisplayCelebrateVideo] = useState(true);
  const [displayCelebrateAfterVideo, setDisplayCelebrateAfterVideo] = useState(false);
  const [showStart, setShowStart] = useState(true);
  const [displayCelebrateRecord, setDisplayCelebrateRecord] = useState(false);
  const [displayAudio, setDisplayAudio] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [displayJoyful, setDisplayJoyful] = useState(props.world3 ? true : false);
  const [displayVoice, setDisplayVoice] = useState(false);
  const [displayAnimal, setDisplayAnimal] = useState(props.world3 ? true : false);
  const [displayJoyfulVideo, setDisplayJoyfulVideo] = useState(false);
  const [animalSize, setAnimalSize] = useState(props.bigAnimal  ? (props.lizard ? 'lizard' : 'bigAnimal') : 'animateAnimal15')
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };
  const [Exit] = useState(
    generateImageUrl('images/Images/close.png')
  );

  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  //how to get the most recent value of displayAudio
  useEffect(() => {
    if(displayAudio && isIOS()) {
      sleep(5000).then(() => {
        setDisplayCelebrateRecord(true)
        setDisplayCelebrateVideo(false)
        setDisplayAudio(false)
      });
    }
  }, [displayAudio]);

  useEffect(() => {
    if( displayCelebrateAfterVideo && isIOS()) {
      sleep(5000).then(() => {
        closeCelebrate(props)
      });
    }
  }, [displayCelebrateAfterVideo]);

  useEffect(() => {
    if( displayVoice && isIOS()) {
      sleep(5000).then(() => {
        setAudioReady(false);
        setDisplayAnimal(false);
        setDisplayVoice(false);
        setDisplayJoyfulVideo(true)
      });
    }
  }, [displayVoice]);

  // Closes the celebrate popup (the entire celebrate module) to show the regular world again.
  const closeCelebrate = (props) => {
    if (props.module.reviewIcon === false) {
      dispatch({
        type: `${props.moduleNum}_SET_stepCompleted`,
        payload: 'celebrate',
      });
    }
    props.module.sectionCompleted = props.module.sectionCompleted + 1
    props.setDisplayCelebrate(false);
  };

  // Shows the video in a display floating in the center of the screen with the world background behind it.
  const displayVideo = () => {
    // If the day is greater than 5, the celebrate video is a slideshow of images with the kid&apos;s recording of the song playing behind it
    if (props.module.currentday < 5) {
      return (
        <>
          <CloudfrontVideoFormat
            source={props.celebrateVideo}
            back='/unit1'
            background={props.background}
            close={props.setDisplayCelebrate}
            ended={() => {
              if (props.module.reviewIcon === false) {
                dispatch({
                  type: `${props.moduleNum}_SET_stepCompleted`,
                  payload: 'celebrate',
                });
              }
              props.module.sectionCompleted = props.module.sectionCompleted + 1
              props.setDisplayCelebrate(false);
            }}
          />
        </>
      );
      // If the day is prior to 6, the celebrate video is a prerecording
    } else {
      return (
        <>
          {displayCelebrateVideo && props.module.cameraOpen === false && (
            <CloudfrontVideoFormat
              source={props.celebrateVideo}
              back='/unit1'
              background={props.background}
              close={props.setDisplayCelebrate}
              ended={() => {
                setDisplayCelebrateVideo(false);
                setDisplayCelebrateRecord(true);
              }}
            />
          )}
          {displayCelebrateRecord && (
            <VideoWebcamRecorder
              background={props.background}
              outputText={props.text}
              name={props.name}
              setDisplayCelebrateAfterVideo={setDisplayCelebrateAfterVideo}
              setDisplayCelebrateRecord={setDisplayCelebrateRecord}
              animal={props.animal}
              close={props.setDisplayCelebrate}
            />
          )}
          {displayCelebrateAfterVideo && props.afterCelebrateVideo && (
            <CloudfrontVideoFormat
              source={props.afterCelebrateVideo}
              back='/unit1'
              background={props.background}
              close={props.setDisplayCelebrate}
              ended={() => {
                if (props.module.reviewIcon === false) {
                  dispatch({
                    type: `${props.moduleNum}_SET_stepCompleted`,
                    payload: 'celebrate',
                  });
                }
                props.module.sectionCompleted = props.module.sectionCompleted + 1
                props.setDisplayCelebrate(false);
              }}
            />
          )}
          {displayCelebrateAfterVideo &&
            !props.afterCelebrateVideo &&
            closeCelebrate(props)}
        </>
      );
    }
  };

  const displayJoyfulJungle = () => {
    return (
      <>
        {!displayJoyfulVideo && <div
          id='recordpage'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          {displayAnimal && !audioReady && (
            <img alt='loading icon' id='loading' src={loading} />
          )}
          {displayVoice && (
            <audio
              autoPlay
              onPlay={() => {
                setAudioReady(true);
              }}
              onEnded={() => {
                // setCrabState(crab)
                setAudioReady(false);
                setDisplayAnimal(false);
                setDisplayVoice(false);
                setDisplayJoyfulVideo(true)
              }}
            >
              <source src={props.animalVoice}></source>
            </audio>
          )}
          {displayAnimal && <img
            className= {animalSize}
            style={audioReady ? {} : { display: 'none' }}
            src={props.animalGIF}
            onLoad={() => setDisplayVoice(true)}
          />}
        </div>}
        {displayJoyfulVideo && <CloudfrontVideoFormat
          source={'45680f06b9f69d1a2b0dcfd2e92f/480.m3u8'}
          back='/unit1'
          background={props.background}
          close={props.setDisplayCelebrate}
          ended={() => {
            setDisplayJoyful(false);
          }}
        />}
      </>
    );
  };

  // Shows the video that was selected above
  const displayWorld2Video = () => {
    return (
      <>
        <div
          id='recordpage'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            alt='back button'
            src={Exit}
            onClick={() => {
              props.setDisplayCelebrate(false);
            }}
          ></img>
          {displayCelebrateVideo && (
            <div id='influencerVideo'>
              <video
                style={videoPlayer}
                autoPlay
                controls={isIOS() ? showStart : false}
                onPause={() => {
                  setShowStart(true);
                }}
                onPlaying={() => {
                  setShowStart(false);
                }}
                onEnded={() => setDisplayAudio(true)}
                onError={() => setDisplayAudio(true)}
                playsInline
              >
                <source src={props.influencerVideo} type='video/mp4'></source>
              </video>
            </div>
          )}

          {displayAudio && (
            <audio
              autoPlay
              onEnded={() => (
                setDisplayCelebrateRecord(true), setDisplayCelebrateVideo(false), setDisplayAudio(false)
              )}
            >
              <source src={props.voice2}></source>
            </audio>
          )}

          {displayCelebrateRecord && (
            <VideoWebcamRecorder
              background={props.background}
              outputText={props.text}
              name={props.name}
              setDisplayCelebrateAfterVideo={setDisplayCelebrateAfterVideo}
              setDisplayCelebrateRecord={setDisplayCelebrateRecord}
              animal={props.animal}
              voice1={props.voice1}
              close={props.setDisplayCelebrate}
            />
          )}
          {displayCelebrateAfterVideo && (
            <audio
              autoPlay
              onPlay={() => {
                setAudioReady(true);
              }}
              onEnded={() => closeCelebrate(props)}
            >
              <source src={props.voice3}></source>
            </audio>
          )}
          {displayCelebrateAfterVideo && (
            <img
              alt='animal animation'
              className= {animalSize}
              style={audioReady ? {} : { display: 'none' }}
              src={props.animation}
            />
          )}
        </div>
      </>
    );
  };
  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      {props.world3 ? 
      (displayJoyful ? displayJoyfulJungle() : displayWorld2Video())
      :
      (props.influencerVideo ? displayWorld2Video() : displayVideo())}
    </>

  )
}